"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenAdvisorWaitlistStatus = void 0;
var AvenAdvisorWaitlistStatus;
(function (AvenAdvisorWaitlistStatus) {
    AvenAdvisorWaitlistStatus["inWaitlist"] = "inWaitlist";
    AvenAdvisorWaitlistStatus["notInWaitlist"] = "notInWaitlist";
    AvenAdvisorWaitlistStatus["allowedToJoin"] = "allowedToJoin";
})(AvenAdvisorWaitlistStatus || (exports.AvenAdvisorWaitlistStatus = AvenAdvisorWaitlistStatus = {}));
